<i class="far" [ngClass]="{'fa-search': search.length < 1, 'fa-times text-info': search.length > 0}" (click)="search = ''"></i>
<input type="text" [(ngModel)]="search" placeholder="{{placeholder | lang}}" (change)="$event.stopPropagation()" (focus)="onfocus()" (blur)="onblur()" />
<small>{{matches}} / {{totals}}</small>
<i *ngIf="groups.length > 1" class="fa fa-filter" [ngClass]="{'active' : filtered}" (click)="select()"></i>

